import { jsx as e } from "react/jsx-runtime";
import o from "./LabelTooltip.js";
const m = (r, t) => r && t ? /* @__PURE__ */ e(o, {
  label: r,
  tooltip: t
}) : r;
export {
  m as default,
  m as getFieldLabel
};
